// extracted by mini-css-extract-plugin
export default {"container":"erlebnissportPage_container__8svxe","abteilungen":"erlebnissportPage_abteilungen__aXuMD"};